<div class="login-content">
  <mat-card appearance="outlined" class="login-container mat-elevation-z8">
    <mat-card-content>
      <mat-card-title>
        <p>Predict</p>
        <h1 class="login-title">{{ 'login.title' | translate }}</h1>
      </mat-card-title>
      <button mat-flat-button color="primary" (click)="loginWithGluu()" [disabled]="loading">
        <mat-icon>login</mat-icon>
        {{ 'login.login-button' | translate }}
      </button>
    </mat-card-content>
    <mat-card-footer *ngIf="loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </mat-card-footer>
  </mat-card>
</div>
